import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAlgoliaContextComponentState {
  algoliaContextComponent: string;
}
const initialState: IAlgoliaContextComponentState = {
  algoliaContextComponent: '',
};

const algoliaContextComponentSlice = createSlice({
  name: 'algoliaContextComponent',
  initialState,
  reducers: {
    setAlgoliaContextComponent: (
      state: IAlgoliaContextComponentState,
      action: PayloadAction<IAlgoliaContextComponentState>
    ) => {
      state.algoliaContextComponent = action.payload.algoliaContextComponent;

      return state;
    },
  },
});

export const { setAlgoliaContextComponent } = algoliaContextComponentSlice.actions;
export const algoliaContextComponentReducer = algoliaContextComponentSlice.reducer;
